/* "Recent designs" card on Home (handoff screen 1): the 4 newest library designs. */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { recentDesigns } from '../../api/library.js';
import { Skeleton } from '../../ui/index.jsx';
import { useTranslation } from 'react-i18next';

const COLORS = ['coral', 'green', 'navy', 'blue'];
const when = (iso, t, lang) => {
  if (!iso) return '';
  const d = new Date(iso);
  const days = Math.floor((Date.now() - d.getTime()) / 86400000);
  if (days <= 0) return t('home.recent.editedToday');
  if (days === 1) return t('common.yesterday');
  return d.toLocaleDateString(lang, { month: 'short', day: 'numeric' });
};

export default function RecentDesigns({ className }) {
  const { t, i18n } = useTranslation('bv');
  const [items, setItems] = useState(null);
  useEffect(() => {
    let gone = false;
    recentDesigns(4).then((r) => { if (!gone) setItems(r.ok ? r.items : []); });
    return () => { gone = true; };
  }, []);
  return (
    <section className={`bv-card bv-recent ${className || ''}`} aria-labelledby="bv-recent-title" data-testid="recent-designs">
      <div className="bv-recent__head">
        <h2 id="bv-recent-title" className="bv-section-title">{t('home.recent.title')}</h2>
        <Link to="/library" className="bv-recent__all">{t('home.recent.seeAll')}</Link>
      </div>
      {!items ? (
        <div className="bv-recent__grid">{[0, 1, 2, 3].map((i) => <Skeleton key={i} height="100%" radius={18} className="bv-recent__skel" />)}</div>
      ) : items.length === 0 ? (
        <div className="bv-recent__empty">
          <p className="bv-small bv-muted">{t('home.recent.empty')}</p>
          <Link to="/design" className="bv-recent__all">{t('home.recent.first')}</Link>
        </div>
      ) : (
        <div className="bv-recent__grid">
          {items.map((d, i) => (
            <Link key={d.id} to={`/library?open=${encodeURIComponent(d.id)}`} className={`bv-recent__item bv-recent__item--${COLORS[i % 4]}`}>
              {d.thumbnailUrl ? <img src={d.thumbnailUrl} alt="" loading="lazy" /> : <span className="bv-recent__blob" />}
              <span className="bv-recent__label">
                <b>{d.name || t('common.untitled')}</b>
                <small>{when(d.updatedAt || d.createdAt, t, i18n.language)}</small>
              </span>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
